import { Injectable } from '@angular/core';
import { ComplexFormParent } from '../utils/complex-form-parent';
import { Office } from '@tangilla/tg-ng-models';

@Injectable({
  providedIn: 'root'
})
export class DlTransferService extends ComplexFormParent {

  override initializeOnAfterRenderPage() {

  }

  override initializeOnCurrentPageChanging(){
    super.initializeOnCurrentPageChanging();
    this.surveyService.surveyModel.onAfterRenderPage.add((sender, options) => {
      const currentPage = sender.currentPage;
      switch(currentPage.name) {
        case 'Confirmation':
          this.buildOrderConfirmation('dr_transfer');
          break;
      }
    })
  }

  override initializeOnValueChanged() {
    // Call previous definitnion from parent class
    super.initializeOnValueChanged();
    this.surveyService.surveyModel.onValueChanged.add((sender, options) => {
      if(options.name==="isCorp"){
        this.officesUtilsService.setOfficeNameInSurvey(sender.getValue(options.name));
      } else if(options.name === 'LicType') {
          // If it's not a Broker/Appraiser license - We need to stop the form
          const value = this.surveyService.surveyModel.getValue('LicType');
          if(value && ['Broker', 'Appraiser'].indexOf(value) === -1) {
            this.errorsService.exitForm('Error', 'Only Broker and Appraiser licenses are allowed to transfer.');
          }
      } else if(options.name === 'office') { // processOfficeDetailsInSelection()
          const officeIdSelected = sender.getValue('office');
          if(officeIdSelected) {
            this.surveyService.isLoading = true;
            this.officesApiService.getOffice(officeIdSelected).subscribe({
              next: (office: any) => {
                sender.setVariable('selected_office', office);
                sender.setVariable('office_name', office.business_name);
                sender.setVariable('dr_name', office.field_description.designated_realtor);
                this.surveyService.isLoading = false;
                this.validateMlsOfChoice(office);
                this.refreshTransitionRequiredFlag();
              },
              error: (error) => {
                this.surveyService.surveyModel.setVariable('selected_office', null);
                this.surveyService.isLoading = false;
                this.errorsService.processError(error, 'soft')
              }
            })
          }
      } else if(options.name === 'Office-Search-Type' ) {
        if(options.value === 'Current') {
          this.surveyService.surveyModel.setVariable("office_name", this.surveyService.officeRecord?.business_name);
          sender.setVariable('dr_name', this.surveyService.officeRecord?.field_description?.designated_realtor);
          this.surveyService.surveyModel.setVariable('selected_office', null);
          this.refreshTransitionRequiredFlag()
        }else {
          this.officesUtilsService.setOfficeNameInSurvey(sender.getQuestionByName('isCorp')?.value);
        }
      }
      else if(options.name === 'business_name') {
        const businessName = options.value;
        if(businessName && businessName.length > 0) {
          this.surveyService.surveyModel.setVariable('office_name', businessName);
        }
      }
    })
  }

  private refreshTransitionRequiredFlag() {
    const mainRelationshipId = this.surveyService.personRelationships.find(r => r.is_main_relationship === true)?.relationship_id;
    const officeNrdsId = this.surveyService.surveyModel.getValue('office') || this.surveyService.officeId;

    if(officeNrdsId) {
      const body = {
        relationship_id: mainRelationshipId,
        office_nrds_id: officeNrdsId
      }
      this.surveyService.isLoading = true;
      this.applicationsService.getValidateTransitionRequired(body)
      .subscribe({
        next: (validateResponse: any) => {
          this.surveyService.surveyModel.setValue('transition_required', validateResponse.transition_required)
          this.surveyService.surveyModel.setVariable('can_partial_transition_to_realtor', validateResponse.can_partial_transition_to_realtor)
          this.surveyService.surveyModel.setVariable('can_partial_transition_to_mls', validateResponse.can_partial_transition_to_mls)

          if(validateResponse.transition_required) {

            if(validateResponse.can_partial_transition_to_realtor || validateResponse.can_partial_transition_to_mls) {
              this.surveyService.surveyModel.setValue('partial_transition', true);
            }
            else {
              this.surveyService.surveyModel.setValue('partial_transition', false);
            }

            // if this is a branch office and a transition is required, we have to stop the form, we cannot take over branch offices that are not compliant with the applicants membership
            if(this.surveyService.officeRecord?.tangilla_office.local_main_office_id) {
              this.surveyService.isLoading = false;
              this.errorsService.exitForm('We have detected a problem.', 'We are unable to continue.\nReason: You cannot take over a branch office that is not compliant with your membership.');
            }
            // Transition is required and office is a realtor office, the member needs to be directed to do a Membership Application instead (if no non-terminated nrds subscription is found?)
            else if (
              ( this.surveyService.surveyModel.getValue('Office-Search-Type') === 'Current' && this.surveyService.officeRecord?.tangilla_office_class === 'Realtor' )  ||
              ( this.surveyService.surveyModel.getVariable('selected_office')  && this.surveyService.surveyModel.getVariable('selected_office').tangilla_office_class === 'Realtor' )
            ){
              this.surveyService.isLoading = false;
              this.errorsService.exitForm('Error', 'The office you have selected requires a REALTOR® membership. Please complete a Membership Application instead.');
            }
            else {
              this.surveyService.surveyModel.setValue('tangilla_sub_class_from', validateResponse.office_tangilla_office_class);
              this.surveyService.isLoading = false;
            }
          } else {
            this.surveyService.isLoading = false;
          }
        },
        error: (error: any) => {
          this.errorsService.processError(error);
        }
      })
    } else {
      this.surveyService.surveyModel.getQuestionByName('officesfound')['html'] = '';
      this.surveyService.surveyModel.setValue('transition_required', false);
      this.surveyService.surveyModel.setValue('tangilla_sub_class_from', null);
      this.surveyService.surveyModel.setValue('partial_transition', false);
    }

  }

}
